import axios from 'axios'
import { AutomationRuleDetailResponse } from 'src/models/automationRules.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getAutomationRuleDetail = async (
  ruleId: string,
): Promise<AutomationRuleDetailResponse> =>
  getResponseData(
    axios.get<AutomationRuleDetailResponse>(
      `/rules/${ruleId}/details`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
